import { $api } from '../../global';

export const getUniversityByName = (univerName?: string | string[]) => async () => {
  const { data } = await $api.get('/university-info', {
    params: { univer_name: univerName }
  });

  return data;
};
